import { Component, OnInit, Input } from '@angular/core';

import * as Services from '@shared/core/services';
import * as State from '@shared/state';
import { Controllers } from '@shared/core/controllers';

import { ModalViewComponent } from '../modal-view.shared.component';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-modal-for-reward',
    templateUrl: './modal-for-reward.shared.component.html',
    styleUrls: ['./modal-for-reward.shared.component.scss']
})
export class ModalForRewardComponent extends ModalViewComponent implements OnInit {
    public product$: Observable<APICommon.IMemberFreeProductModel>;
    public title$: Observable<string>;
    public loading$: Observable<boolean>;
    public image$: Observable<State.IFreeProductImage>;

    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public controllers: Controllers,
    ) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this.product$ = this.controllers.loyalty.getFreeProduct$(this.modalData.productId);
        this.title$ = this.controllers.loyalty.getFreeProductTitle$(this.modalData.productId);
        this.image$ = this.controllers.images.getImageForFreeProductByFreeProductId$(this.modalData.productId);
        this.loading$ = this.controllers.loyalty.isLoadingLoyaltyInfoForMember$();
    }
}
